namespace SP {
    export enum OrderState {
        PendingPresell = -20,
        PendingReturnShipment = -10,
        None = 0,
        ReadyForPacking = 1,
        ItemsMissing = 2,
        Error = 3,
        Packing = 4,
        Packed = 5,
        Cancelled = 6
    }

}